import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { ExternalRequisitionStatus } from '../../models/requisitions/interfaces/external-requisition-status';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class RequisitionStatusProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/external-requisition-status';

  /**
   * Obtiene todos los estados de requisición externa
   */
  public getAllStatuses(): Observable<ApiResponse<ExternalRequisitionStatus[]>> {
    return this.httpClient.get<ApiResponse<ExternalRequisitionStatus[]>>(`${this.baseUrl}/all`);
  }

  /**
   * Obtiene un estado de requisición externa por ID
   */
  public getStatusById(id: string): Observable<ApiResponse<ExternalRequisitionStatus>> {
    return this.httpClient.get<ApiResponse<ExternalRequisitionStatus>>(`${this.baseUrl}/${id}`);
  }

  /**
   * Crea un nuevo estado de requisición externa
   */
  public createStatus(data: ExternalRequisitionStatus): Observable<ApiResponse<ExternalRequisitionStatus>> {
    return this.httpClient.post<ApiResponse<ExternalRequisitionStatus>>(this.baseUrl, data);
  }

  /**
   * Actualiza un estado de requisición externa existente
   */
  public updateStatus(data: ExternalRequisitionStatus): Observable<ApiResponse<ExternalRequisitionStatus>> {
    return this.httpClient.put<ApiResponse<ExternalRequisitionStatus>>(`${this.baseUrl}/${data.id}`, data);
  }

  /**
   * Elimina un estado de requisición externa por ID
   */
  public deleteStatus(id: string): Observable<ApiResponse<object>> {
    return this.httpClient.delete<ApiResponse<object>>(`${this.baseUrl}/${id}`);
  }
}
